import * as React from 'react';
import Item from './item';

const css = require('./body.css').default;

export default function ({items, onChange}: {
    items: item[],
    onChange: (item: item[]) => void,
}) {
    return (
    <div id={css.body}>
        {items.map((i, idx) => <Item key={idx}
            item={i}
            onChange={item => onChange(items.slice(0, idx).concat([item]).concat(items.slice(idx+1)))}
            onDel={() => onChange(items.slice(0, idx).concat(items.slice(idx+1)))}
            onDup={() => onChange(items.slice(0, idx).concat([items[idx]]).concat(items.slice(idx)))}
        />)}
    </div>);
}

type item = {
    product: {
        code: string,
        name: string,
    }
    classQty: number,       // 每班訂購數量
    classCnt: number,
    memo: string | null,
}
